<template>
  <div v-if="loading" class="text-center" style="margin-top: 10em">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else>
    <transition appear name="slide-fade">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header">
              <h4 class="text-orange fw-bold">Nueva membresía</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-12 form-group">
                  <label>Nombres <small>(como aparece en la cedula)</small></label>
                  <input v-model="nombres" class="form-control" type="text" />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Apellidos <small>(como aparecen en la cedula)</small></label>
                  <input v-model="apellidos" class="form-control" type="text" />
                </div>
                <div class="col-lg-12 form-group">
                  <label>No. de identificación <small>(numero de cedula sin puntos)</small></label>
                  <input v-model="identificacion" class="form-control" type="text" @keypress="isNumber($event)" />
                </div>
                <div class="col-lg-12 form-group">
                  <label>WhatsApp <small>(numero de whatsapp del usuario, favor confirmar la información)</small></label>
                  <input v-model="whatsapp" class="form-control" type="text" @keypress="isNumber($event)"
                    v-on:blur="copiar" />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Celular <small>(numero telefonico del usuario, favor confirmar la información)</small></label>
                  <input v-model="celular" class="form-control" type="text" @keypress="isNumber($event)" />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Correo electrónico <small>(correo electrónico de contacto, favor confirmar la
                      información)</small></label>
                  <input v-model="email" class="form-control" type="text" />
                </div>
                <div class="form-group">
                  <label>Ciudad <small>(ciudad de residencia)</small></label>
                  <v-select v-model="ciudad" @search="get_ciudades" label="ciudad" :options="ciudades"></v-select>
                </div>
                <div class="col-lg-12 form-group">
                  <label>Dirección <small>(dirección de residencia, confirmar esta información)</small></label>
                  <input v-model="direccion" class="form-control" type="text" />
                </div>
                <!--  <div class="col-lg-12 form-group">
                  <label>Estado</label>
                  <select v-model="estado" class="form-control">
                    <option value="0">Interesado</option>
                    <option value="1">Pendiente</option>
                    <option value="3">Exitosa</option>
                  </select>
                </div> -->
                <div class="col-lg-12 text-end">
                  <button v-on:click="set_membresia(1)" class="btn btn-orange rounded-pill ms-1">
                    <i class="bx bx-save"></i>
                    Guardar y finalizar
                  </button>
                  <button v-on:click="set_membresia(2)" class="btn btn-success rounded-pill ms-1">
                    <i class="bx bx-save"></i>
                    Guardar y continuar <i class="bx bx-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
  name: "Nueva_membresia",
  data() {
    return {
      loading: true,
      nombres: null,
      apellidos: null,
      identificacion: null,
      whatsapp: null,
      celular: null,
      email: null,
      ciudad: null,
      direccion: null,
      estado: 1,
      ciudades: [],
    };
  },
  props: {
    session: Object,
  },
  created: function () { },
  methods: {
    set_membresia: function (step) {
      if (this.nombres == null || this.nombres.trim().length == 0) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita el nombre del usuario.",
        });
        return false;
      }
      if (this.apellidos == null || this.apellidos.trim().length == 0) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita los apellidos del usuario.",
        });
        return false;
      }
      if (this.whatsapp == null || this.whatsapp.trim().length == 0) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita el Whatsapp del usuario.",
        });
        return false;
      }
      if (this.email == null || this.email.trim().length == 0) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita el email del usuario.",
        });
        return false;
      }
      var re = /\S+@\S+\.\S+/;
      var valida_email = re.test(this.email);

      if (!valida_email) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita una dirección de correo electrónico válida.",
        });
        return false;
      }

      this.loading = true;
      var id_ciudad = null;
      if (this.ciudad != null) {
        id_ciudad = this.ciudad.id_ciudad;
      }

      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        nombres: this.nombres,
        apellidos: this.apellidos,
        identificacion: this.identificacion,
        whatsapp: this.whatsapp,
        celular: this.celular,
        email: this.email,
        direccion: this.direccion,
        id_ciudad: id_ciudad,
        estado: this.estado,
      };
      axios
        .post(this.$base_url + "clientes/set_usuario", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            return false;
          }

          switch (step) {
            case 1:
              vm.$router.push("/");
              break;
            case 2:
              vm.$router.push(
                "/beneficiarios/" + response.data.data.id_usuario
              );
              break;
          }
          vm.loading = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    get_ciudades: function (search) {
      if (search == null || search.trim().length == 0) {
        return false;
      }
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          search: search,
        },
      };
      axios
        .get(this.$base_url + "admin/ciudades", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.ciudades = response.data.data.ciudades;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode == 46) {
        evt.preventDefault();
      } else {
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
        ) {
          evt.preventDefault();
        } else {
          return true;
        }
      }
    },
    copiar: function () {
      if (this.celular == null || this.celular == "") {
        this.celular = this.whatsapp;
      }
    },
  },
  mounted: function () {
    this.loading = false;
  },
};
</script>